import { string } from 'yup';

const rule = {
	name: 'systemOptionsQtyAvailable',
	method ({ message, element }) {

		return this.test('systemOptionsQtyAvailable', message, function (value) {

			if (!element.hasAttribute('data-inventory')) {

				return true;

			}
			const available = parseInt(element.getAttribute('data-inventory'), 10);
			if (available < 1) {

				message = 'Sorry, no more are available.';

			}
			message = `Only ${available} available. Please reduce quantity.`;
			const test = value === '' || parseInt(value, 10) <= available;

			const { createError } = this;
			return test || createError({ message });

		});

	},
	schemaType: string
};

export default rule;
